<template>
<div class="advertising_ui" :style='styleBg'>
    <div class="img-container" v-if="datas.csstype=='double'">
        <div class="img-warp img-tow-col">
            <div class="img-box" v-for="(item,i) in datas.items" v-if="i%2==0" @click="goPage(item)">
                <img :src="item.url" :style="imgStyle">
                <p v-if="item.name">{{item.name}}</p>
            </div>
        </div>
        <div class="img-warp img-tow-col">
            <div class="img-box" v-for="(item,i) in datas.items" v-if="i%2==1" @click="goPage(item)">
                <img :src="item.url" :style="imgStyle">
                <p v-if="item.name">{{item.name}}</p>
            </div>
        </div>

    </div>
    <div class="img-container" v-else-if="datas.csstype=='one'">
        <div class="img-warp img-three-col">
            <div class="img-box" v-for="(item,i) in datas.items" v-if="i%3==0" @click="goPage(item)">
                <img :src="item.url" :style="imgStyle">
                <p v-if="item.name">{{item.name}}</p>
            </div>
        </div>
        <div class="img-warp img-three-col">
            <div class="img-box" v-for="(item,i) in datas.items" v-if="i%3==1" @click="goPage(item)">
                <img :src="item.url" :style="imgStyle">
                <p v-if="item.name">{{item.name}}</p>
            </div>
        </div>
        <div class="img-warp img-three-col">
            <div class="img-box" v-for="(item,i) in datas.items" v-if="i%3==2" @click="goPage(item)">
                <img :src="item.url" :style="imgStyle">
                <p v-if="item.name">{{item.name}}</p>
            </div>
        </div>
    </div>

    <div class="img-container mult" v-else-if="datas.csstype=='mult'">
        <div class="img-warp">
            <div class="img-box" v-for="(item,i) in datas.items" v-if="i%2==0" @click="goPage(item)">
                <img :src="item.url" :style="imgStyle">
                <p>{{item.name}}</p>
            </div>
        </div>
        <div class="img-warp">
            <div class="img-box" v-for="(item,i) in datas.items" v-if="i%2==1" @click="goPage(item)">
                <img :src="item.url" :style="imgStyle">
                <p>{{item.name}}</p>
            </div>
        </div>
    </div>

    <div class="advertising" :class="datas.csstype" v-else>
        <div class="big" v-if="i==0" v-for="(item,i) in datas.items" :key="i" @click="goPage(item)">
            <img :style="imgStyle" :src="item.url">
        </div>
        <div class="small-box">
            <div class="small" v-for="(item,i) in datas.items" v-if="i<maxPic&&i>0" :key="i" @click="goPage(item)">
                <img :style="imgStyle" :src="item.url">
            </div>
        </div>
    </div>

</div>
</template>

<script>
import {
    jAlert3
} from "@/base/jAlert/jAlert";
export default {
    props: ["datas"],
    data() {
        return {
            maxPic: 0
        };
    },
    computed: {
        styleBg(){
            return `background:${this.datas.bgColor};`
        },
        imgStyle() {
            if (this.datas.radius == 'circular') {
                return `border-radius:0.213333rem;`
            } else {
                return ''
            }
        },
    },
    methods: {
        goPage(item) {
            if (item.link && item.link != '') {
                if (item.link.indexOf('http') != -1) {
                    this.goLink(item.link)
                   
                } else {
                    jAlert3(item.link)
                    return;
                }
            }
        }
    },
    mounted() {
        if (this.datas.csstype == 'one') {
            this.maxPic = 6
        } else {
            this.maxPic = 3
        }
    }

};
</script>

<style lang="less" scoped>
@import url("~@/styles/mixin.less");

.advertising_ui {
    margin-top: -0.266667rem;

    .title {
        padding: 0 0.053333rem;
        line-height: 0.586667rem;
        font-size: 16px;
        color: #1d1e2c;
    }

    .advertising {
        padding: 0 0.266667rem;
        display: flex;
        flex-wrap: wrap;
        clear: both;

        .img {
            margin: 0.266667rem 0.133333rem 0;

            img {
                width: 100%;
                height: 100%;
            }
        }

        &.one {
            img {
                width: 2.88rem;
                height: auto;

            }

            p {
                text-align: center;
                line-height: 1.066667rem;
                max-height: 1.066667rem;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 15px;
                color: #333333;
                white-space: nowrap;
            }
        }

        &.two,
        &.three {
            display: block;

            &::after {
                content: "";
                display: block;
                height: 0;
                clear: both;
            }

            .big {
                float: left;
                margin: 0.266667rem 0.133333rem 0;
                width: 4.373333rem;
                height: 5.493333rem;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .small-box {
                float: right;
            }

            .small {
                margin: 0.266667rem 0.133333rem 0;
                width: 4.56rem;
                height: 2.586667rem;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        &.three {
            .big {
                float: right;
            }

            .small-box {
                float: left;
            }
        }
    }

    .img-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 0.4rem;
        &.mult {
            .img-warp {
                .img-box {
                p {
                    margin-top: 2px;
                    line-height: 0.533333rem;
                    max-height:0.533333rem;
                }
                }
            }
        }
        .img-warp {
            width: 4.4rem;

            &.img-three-col {
                width: 2.88rem;

                .img-box {
                    p {
                        margin-top: 0.266667rem;
                        text-align: center;
                        line-height: 0.533333rem;
                        max-height: 1.066667rem;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        white-space: normal;
                        word-break: break-all;
                        overflow: hidden;
                    }
                }

            }

            &.img-tow-col {
                display: flex;
                align-items: center;
                flex-direction: column;

                .img-box {
                    width: 2.88rem;

                    p {
                        margin-top: 0.266667rem;
                        text-align: center;
                        line-height: 0.533333rem;
                        max-height: 1.066667rem;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        white-space: normal;
                        word-break: break-all;
                        overflow: hidden;
                    }
                }
            }

            .img-box {
                margin-top: 0.266667rem;
                width: 100%;

                img {
                    width: 100%;
                }

                p {
                    line-height: 1.066667rem;
                    max-height: 1.066667rem;

                    font-size: 15px;
                    color: #333333;
                    white-space: nowrap;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    white-space: normal;
                    word-break: break-all;
                    overflow: hidden;
                }
            }
        }
    }

    .img-col {
        display: flex;
        flex-wrap: wrap;

        &.img-three-col {
            .img-box {
                width: 33.3%;
            }

        }

        &.img-tow-col {
            .img-box {
                width: 50%;
            }

        }

        .img-box {

            display: flex;
            flex-direction: column;
            align-items: center;
            line-height: 1.4;

            img {
                width: 2.8rem;
                height: 2.8rem;
            }

            p {
                margin-top: 0.266667rem;
                font-size: 14px;
                color: #333333;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                white-space: normal;
                word-break: break-all;
                overflow: hidden;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Advertising.vue